import React, { ReactElement } from 'react';

import ProgressItemDetail from './ProgressItemDetail';
import { ProgressDropdownOption } from './types';

interface ProgressItemProps {
	option: ProgressDropdownOption;
	onSelect: (option: ProgressDropdownOption) => void;
}

const ProgressItem = ({ option, onSelect }: ProgressItemProps): ReactElement => {
	const { value } = option;

	return (
		<div
			key={value}
			className={'flex cursor-pointer py-1 transition duration-1000 hover:bg-secondary-main'}
			onClick={() => onSelect(option)}
		>
			<ProgressItemDetail option={option} />
		</div>
	);
};

export default ProgressItem;
